import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=86a72472&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QIcon} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSeparator,QIcon}, component.options.components || {})
